import React, {Fragment} from 'react';
import propsAreEqual from 'react-fast-compare';
import {css} from '@emotion/css';
import {TableData} from '@common/SortableTable';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

type Props = {
  row: TableData;
}

const MemoizedStandardTypography = React.memo(StandardTypography);

const SortableTableRow = ({ row }: Props) => {
  return (
    <tr data-testid="sortable-table-row">
      {Object.keys(row).map((key: string, index) => {
        if(row[key].columnWidth === '0%') return <Fragment key={index}></Fragment>;
        return (
          <td key={index} className={css({ width: row[key].columnWidth})}>
            <MemoizedStandardTypography>{row[key].displayValue}</MemoizedStandardTypography>
          </td>
        );})}
    </tr>
  );
};

export default React.memo(SortableTableRow, propsAreEqual);
